import tree from "../../../components/tree.vue";
import iTable from "../../../components/Table.vue";
import IPagination from "../../../components/pagination.vue";
import {
    domainName
} from "../../../utility/index"
import {
    downLoadTemplateFile,
    exportTerminalFile
} from '../../../api/config/modules/TerminalFile'
import moment from "moment";
export default {
    name: "TerminalFile",
    components: {
        tree,
        iTable,
        IPagination
    },
    data() {
        return {
            isCollapse: false,
            formInline: {
                simIccicd: '',
                simId: '',
                assetState: '',
            },
            typeList: [{
                id: '',
                name: this.$t('common.all')
            },{
                id: 0,
                name: this.$t('SIMFile.inUse')
            },{
                id: 1,
                name: this.$t('SIMFile.abandoned')
            }],
            height: '550',
            list: [],
            option: {
                stripe: true,
                border: true,
                loading: false,
                highlightCurrentRow: false,
                mutiSelect: true,
                serialNumber: true,
            },
            columns: [{
                prop: "simIccicd",
                label: this.$t('TerminalFile.simIccicd'),
                align: "center",
                width: "260px",
            },
            {
                prop: "simId",
                label: this.$t('VehicleManagement.simNumber'),
                align: "center",
                width: "260px"
            },
            {
                prop: "assetState",
                label: this.$t('SIMFile.assetStatus'),
                align: "center",
                width: "200px",
                render: (h, params) => {
                    return h('el-tag', {
                        props: { type: params.row.assetState === null ? '' : params.row.assetState === 0 ? 'success' : 'danger' }
                    }, params.row.assetState === null ? '' : params.row.assetState === 0 ? this.$t('SIMFile.inUse'): this.$t('SIMFile.abandoned'))
                }
            },
            {
                prop: "simStatus",
                label: this.$t('SIMFile.cardStatus'),
                align: "center",
                width: "200px"
            },
            {
                prop: "activeTime",
                label: this.$t('SIMFile.activationDate'),
                align: "center",
                width: "260px",
            },
            {
                prop: "expireTime",
                label: this.$t('SIMFile.expirationDate'),
                align: "center",
                width: "200px",
            },
            {
                prop: "supplier",
                label: this.$t('ContractManagement.supplierName'),
                align: "center",
                width: "260px"
            },
            {
                prop: "carrier",
                label: this.$t('SIMFile.operators'),
                align: "center",
                width: "200px",
            },
            {
                prop: "simUsage",
                label: this.$t('SIMFile.cardUsage'),
                align: "center",
                width: "200px",
            },
            {
                prop: "syncTime",
                label: this.$t('SIMFile.syncTime'),
                align: "center",
                width: "200px",
            },
            {
                prop: "remarks",
                label: this.$t('common.remarks'),
                align: "center",
                width: "200px",
            },
            ],
            operates: {
                width: 100,
                fixed: "right",
                list: [
                ],
            },
            currentPage: 1,
            pageSize: 10,
            total: 1,
            dialogFormVisible: false,
            formLabelWidth: '100px',
            diaTitle: '',
            btnType: '',
            rules: {
                simIccicd: [{
                    required: true,
                    message: this.$t('SIMFile.enterIccicd'),
                    trigger: 'blur'
                }],
                supplier: [{
                    required: true,
                    message: this.$t('SIMFile.enterSupplier'),
                    trigger: 'blur'
                }],
            },
            form: {
                simIccicd: '',
                supplier: '',
                remarks: '',
            },
            disabled: false,
            isShow: true,
            selected: [],
            abandonedDisabled: true,
            id: '',
            name: '',
            dialogBatchFormVisible: false
        }
    },
    created() {
        this.getAllTerminal()
    },
    methods: {
        toggleSideBar() {
            this.isCollapse = !this.isCollapse
            this.$store.dispatch('menuTab/toggleSideBar', this.isCollapse)
        },
        getAllTerminal() {
            let param = {
                simIccicd: this.formInline.simIccicd,
                simId: this.formInline.simId,
                assetState: this.formInline.assetState,
                pageNum: this.currentPage,
                pageSize: this.pageSize,
            }
            this.$store.dispatch('SIMFile/GET_SELECTSIM', param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        this.list = res.data.data.list
                        this.$refs.page.CommandTotal = res.data.data.total
                    }
                }
            }).catch(err => { })
        },
        onSearch() {
            this.$refs.page.CommandCurrentPage = 1
            this.currentPage = 1
            this.getAllTerminal()
        },
        onClear() {
            this.formInline = {
                simIccicd: '',
                simId: '',
                assetState: '',
            }
            this.getAllTerminal()
        },
        addTerminal() {
            this.dialogFormVisible = true
            this.diaTitle = this.$t('common.btn.add')
            this.btnType = 'add'
            this.disabled = false
            this.isShow = true
            this.form.supplier = ''
            this.form.remarks = ''
            this.form.simIccicd = ''
            this.$nextTick(() => {
                this.$refs.form.resetFields()
            })
        },
        editTerminal() {
            this.dialogFormVisible = true
            this.diaTitle = this.$t('common.btn.edit')
            this.btnType = 'edit'
            this.disabled = true
            this.isShow = true
            this.$nextTick(() => {
                this.$refs.form.clearValidate()
            })
            this.form.supplier = this.selected[0].supplier
            this.form.remarks = this.selected[0].remarks
            this.form.simIccicd = this.selected[0].simIccicd
        },
        abandonedTerminal() {
            this.dialogFormVisible = true
            this.diaTitle = this.$t('SIMFile.abandoned')
            this.btnType = 'abandoned'
            this.isShow = false
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let param = {
                        simIccicd: this.form.simIccicd,
                        supplier: this.form.supplier,
                        remarks: this.form.remarks,
                    }
                    if (this.btnType == 'add') {
                        this.$store.dispatch('SIMFile/GET_INSERTSIM', param).then(res => {
                            if (res.data.code == 200) {
                                this.$message.success(this.$t('common.btn.addSuccess'))
                                this.dialogFormVisible = false;
                                this.getAllTerminal();
                                this.closeDia();
                            } else {
                                this.$message.error(res.data.msg)
                            }

                        }).catch(err => { })
                    } else if(this.btnType == 'edit') {
                        param.simIccicd = this.selected[0].simIccicd
                        this.$store.dispatch('SIMFile/GET_UPDATEREMARKS', param).then(res => {
                            if (res.data.code == 200) {
                                this.$message.success(this.$t('common.btn.editSuccess'))
                                this.dialogFormVisible = false;
                                this.getAllTerminal();
                                this.closeDia();
                            } else {
                                this.$message.error(res.data.msg)
                            }

                        }).catch(err => { })
                    } else {
                        param.simIccicd = this.selected[0].simIccicd
                        this.$store.dispatch('SIMFile/GET_ABANDONEDSIM', param).then(res => {
                            if (res.data.code == 200) {
                                this.$message.success(this.$t('SIMFile.abandonedSuccessfully'))
                                this.dialogFormVisible = false;
                                this.getAllTerminal();
                                this.closeDia();
                            } else {
                                this.$message.error(res.data.msg)
                            }

                        }).catch(err => { })
                    }


                } else {
                    return false;
                }
            });
        },
        cancle(formName) {
            this.dialogFormVisible = false;
            this.form = {
                simIccicd: '',
                supplier: '',
                remarks: '',
            }
        },
        closeDia() {
            this.form = {
                simIccicd: '',
                supplier: '',
                remarks: '',
            }
            this.dialogFormVisible = false;
        },

        deleteTerminal() {
            this.$confirm(this.$t('common.btn.confirmDelete'), this.$t('common.btn.hint'), {
                cancelButtonText: this.$t('common.btn.cancel'),
                confirmButtonText: this.$t('common.btn.confirm'),
                type: 'warning'
            }).then(res => {
                let param = {
                    simIccicd: this.selected.map(item => item.simIccicd).join()
                }
                this.$store.dispatch('SIMFile/GET_DELETESIM', param).then(response => {
                    if (response.data.code == 200) {
                        this.getAllTerminal()
                        this.$message.success(this.$t('common.btn.deleteSuccess'))
                    } else {
                        this.$message.error(response.data.msg)
                    }
                }).catch(error => { })
            }).catch(err => {

            })
        },

        BulkImport() {
            this.dialogBatchFormVisible = true
        },

        TemplateFile() {
            if (domainName) {
                if (domainName.split(':')[0] !== 'localhost') {
                    let url = `https://${domainName}/v1/exportTemplate/exportSimTemplate`
                    location.href = url

                } else {
                    let host = 'localhost:8080'
                    let url = `https://${host}/v1/exportTemplate/exportSimTemplate`
                    location.href = url

                }
            }
        },

        uploadFile(e) {
            let dom = document.getElementById('uploadDom')
            let file = dom.files[0];
            let formData = new FormData()
            formData.append('File', file)
            let types = file.name.split('.')[1]
            if (types != "xlsx" && types != "xls") {
                this.$message.error(this.$t('TerminalFile.form.choseExcel'));
                return false;
            } else {
                this.$store.dispatch('SIMFile/GET_IMPORTSIM', formData).then(res => {
                    if (res.data.code == 200) {
                        this.$message.success(this.$t('common.btn.fileUploadSuccess'))
                        this.dialogBatchFormVisible = false;
                        this.getAllTerminal()
                    } else {
                        this.$message.error(res.data.msg)
                    }
                    document.getElementById('uploadDom').value = ''
                }).catch(err => {
                    this.$message.error(this.$t('common.btn.fileUploadError'))
                    document.getElementById('uploadDom').value = ''
                })
            }
        },
        closeBatchDia() {
            this.dialogBatchFormVisible = false
        },
        downTerminal() {
            if (domainName) {
                if (domainName.split(':')[0] !== 'localhost') {
                    let url = `https://${domainName}/v1/getExportExcel/exportSim?simId=${this.formInline.simId}&assetState=${this.formInline.assetState}&simIccicd=${this.formInline.simIccicd}`
                    location.href = url

                } else {
                    let host = 'localhost:8080'
                    let url = `https://${host}/v1/getExportExcel/exportSim?simId=${this.formInline.simId}&assetState=${this.formInline.assetState}&simIccicd=${this.formInline.simIccicd}`
                    location.href = url
                }
            }
        },
        handleSelectionChange(val) {
            this.selected = val
            if(this.selected.length > 0) {
                if(this.selected[0].assetState == 1) {
                    this.abandonedDisabled = true
                }else {
                    this.abandonedDisabled = false
                }
            }else {
                this.abandonedDisabled = true
            }
        },
        changeSize(item) {
            this.pageSize = item.pageSize
            this.currentPage = item.pageNum
            this.getAllTerminal();
        },
        onResize: function (x, y, width, height) {
            let box = document.getElementById("leftBox");
            box.style.width = width + "px";
        },
    }
}